var React = require('react');
var ContextContentMixin = require('./../context_content_mixin');
var CustomStylesMixin = require('./../custom_styles_mixin');
var RevealMixin = require('../reveal_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'Background503',

  mixins : [ContextContentMixin, CustomStylesMixin, RevealMixin],

  buttonsClass : function() {
    var ret = "buttons-container";
    if (this.props.has_status_page == 'no') {
      ret += " single-button";
    }
    return ret;
  },

  render : function () {
    return (
      <div className="content-container" style={this.shadow()}>
        <div className="head-line" style={this.secondary_text_color()}>503</div>
        <div className="subheader" style={this.primary_text_color()}>
          Looks like we're having
          <br />
          some server issues.
        </div>
        <div className="hr"></div>
        <div className="clearfix"></div>
        <div className="context" style={this.secondary_text_color()}>
          {this.contextContent()}
        </div>
        <div className={this.buttonsClass()}>
          <a href={this.href(this.props.status_page_url)} style={this.mergeStyles(this.button(), this.has_status_page())} target="_blank">
            <span className="fa fa-power-off"></span>
            View Statuspage
          </a>
          <a href={this.support_email_address()} style={this.button()} target="_blank">
            <span className="fa fa-warning"></span> 
            Report A Problem
          </a>
        </div>
      </div>
    )
  }

})



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/background/503.jsx